import { QueueDisplayScreen, RegisterDisplayRequest } from '../models/Entities/Turnero';
import { apiRequest, buildURL } from './commons/CommonService.Functions';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'offices/QueueDisplayScreen';

export const GetQueueDisplayScreens = async (token: string): Promise<QueueDisplayScreen[]> => {
    return apiRequest<QueueDisplayScreen[]>(BaseURL, token, 'GetQueueDisplayScreens');
};

export const GetQueueDisplayScreenById = async (token: string, id: number): Promise<QueueDisplayScreen> => {
    const requestURL = buildURL(BaseURL, id);
    return apiRequest<QueueDisplayScreen>(requestURL, token, 'GetQueueDisplayScreenById');
};

export const CreateQueueDisplayScreen = async (token: string, payload: QueueDisplayScreen): Promise<QueueDisplayScreen> => {
    return apiRequest<QueueDisplayScreen>(BaseURL, token, 'CreateQueueDisplayScreen', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

export const UpdateQueueDisplayScreen = async (token: string, id: number, payload: QueueDisplayScreen): Promise<string> => {
    const requestURL = buildURL(BaseURL, id);
    return apiRequest<string>(requestURL, token, 'UpdateQueueDisplayScreen', {
        method: 'PUT',
        body: JSON.stringify(payload)
    });
};

export const DeleteQueueDisplayScreen = async (token: string, id: number): Promise<string> => {
    const requestURL = buildURL(BaseURL, id);
    return apiRequest<string>(requestURL, token, 'DeleteQueueDisplayScreen', {
        method: 'DELETE'
    });
};

export const RegisterQueueDisplayScreen = async (token: string, payload: RegisterDisplayRequest): Promise<QueueDisplayScreen> => {
    const requestURL = buildURL(BaseURL, 'register');
    return apiRequest<QueueDisplayScreen>(requestURL, token, 'RegisterQueueDisplayScreen', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};
